import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SHIPPING_FEE, propTypes } from '../../util/types';
// CUSTOM: shipping-by-continent
import continents from '../../custom/data/continents.json';
import countries from '../../custom/data/countries.json';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the shipping fee as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemShippingFeeMaybe = props => {
  const { lineItems, intl } = props;

  const shippingFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal
  );

  // CUSTOM: shipping-by-continent start — show destination in shipping label
  let domesticShipping;
  let country;
  let continent;
  if (shippingFeeLineItem && shippingFeeLineItem.metadata) {
    const metadata = shippingFeeLineItem.metadata;
    const code = metadata.buyerCountry;
    country = countries.find(c => c.code === code);
    if (metadata.buyerCountry && metadata.buyerCountry === shippingFeeLineItem.metadata.sellerCountry) {
      domesticShipping = true;
    }
  }
  if (country && country.continent) {
    continent = continents.find(c => c.key === country.continent);
  }
  let destinationLabel = ''
  if (domesticShipping) {
    destinationLabel = ` domestic`;
  } else if (continent) {
    destinationLabel = ` to ${continent.en}`;
  }
  // CUSTOM: shipping-by-continent end

  return shippingFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingFee" />
        {destinationLabel}
      </span>
      <span className={css.itemValue}>{formatMoney(intl, shippingFeeLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemShippingFeeMaybe;
